import TableSkeleton from '../../../components/loaders/TableSkeleton';
import ListHeader from '../../../components/ListHeader';
import { useTranslation } from 'react-i18next';
import WarrantiesTableContainer from '../../../modules/warranties/components/WarrantiesTableContainer';
import useModuleTableHelpers from '../../../hooks/useModuleTableHelpers';
import { hasPermission } from '../../../utils/HelperFunctions';
import Button from '../../../components/buttons/Button';

const Warranties = () => {
  const { t } = useTranslation();

  const { apiData, apiDataLoading, paginationEle, searchEle } = useModuleTableHelpers({
    route: 'admin/warranties',
    withBreadcrumb: true,
    withSearch: true,
    breadcrumbTitle: t('links.warranties'),
    withPagination: true,
    queryKey: 'warranties',
    customSearchPlaceholder: `${t('search_by')} ${t('name')} ${t('or')} ${t('code')}`
  });

  const hasEditPermission = hasPermission(['accessories.edit']);

  const tableHeaders = [
    { label: '#' },
    { label: t('code') },
    { label: t('title') },
    { label: t('is_default') },
    hasEditPermission && { label: t('actions'), customClass: 'actions_col' }
  ];

  if (apiDataLoading && !apiData) return <TableSkeleton columns={6} withoutButton />;

  return (
    <div className="accessories-page-container">
      <ListHeader customClass="table_filters">
        <div className="filter_container">{searchEle}</div>
        {hasEditPermission && <Button text={t('create_warranty')} link="/warranties/create-warranty" />}
      </ListHeader>
      <WarrantiesTableContainer tableHeaders={tableHeaders} data={apiData} noDataMessage={t('no_warranties_found')} lessColumns />
      {paginationEle}
    </div>
  );
};

export default Warranties;
